























































import { Vue, Component, Prop } from 'vue-property-decorator';
import { Session } from '../../utils/Session';
import { getBuildingLogo, getBuildingName } from '../../../src_server/entity/master/buildingData';
import { ContextDataServiceExt } from '../../biz/ContextDataServiceExt';
import { ContextDTO } from '../../../src_server/entity/dto/ContextDTO';
import LineOfficialConnectionDialog from '../line/LineOfficialConnectionDialog.vue';
import { LocalData } from '../../utils/LocalData';

@Component({ components: { LineOfficialConnectionDialog } })
export default class HeaderBase extends Vue {
  private context = new ContextDTO();
  private version = '';
  @Prop({ default: '/' })
  private logoutTo!: string;
  @Prop()
  private logoLink!: string;

  @Prop({ default: true })
  public login!: boolean;

  @Prop({ default: 'さん' })
  nameSurfix!: string;

  get isCO() {
    return Session.isCircleOBuilding();
  }

  showMenu() {
    this.$emit('show-menu');
  }

  get nickName() {
    return this.context.nick_name;
  }

  get logo() {
    const building = Session.getSessionBuildingId();
    if (!building) return '';
    return getBuildingLogo(building);
  }

  get building() {
    const building = Session.getSessionBuildingId();
    if (!building) return '';
    return getBuildingName(building);
  }

  async showOffical() {
    await (this.$refs['LineOfficialConnectionDialog'] as LineOfficialConnectionDialog).show();
  }

  logout() {
    Session.logout();
    this.$router.push(this.logoutTo);
  }

  async created() {
    this.version = LocalData.getLocalVersion();

    if (this.login) {
      // コンテキストを取得
      const contextBiz = new ContextDataServiceExt();
      const context = await contextBiz.getContext();
      if (context) {
        this.context = context;

        this.$nextTick(() => {
          // DAの生徒では表示しないしない
          if (!Session.isCircleOBuilding() && Session.getSessionUserType() === 'stu') {
            return;
          }
          if (!this.context.is_join_line_at) {
            this.showOffical();
          }
        });
      }
    }
  }
}
